import React from "react";
import Payperiod from "./Payperiod";
import Employee from "./Employee";
import Daily from "./Daily";
import { useShiftData } from "../../hooks/shiftData";

const ShiftScheduleOutlet = ({ departmentslug }) => {
    const { shiftData } = useShiftData();

    return (
        <div className="columns">
            <div className="column">
                <Payperiod />
            </div>

            {
                shiftData?.payperiod && (
                    <div className='column'>
                        <Employee departmentslug={departmentslug} />
                    </div>
                )
            }

            {
                shiftData?.employee && (
                    <div className='column'>
                        <Daily />
                    </div>
                )
            }
        </div>
    )
}

export default ShiftScheduleOutlet;